import QRCode from 'qrcode';
import { formatPin } from '../format.js';
import { t } from '../i18n/index.js';
import { el } from './dom.js';

/** QR for paper: rendered large so it stays crisp when the browser scales it to the page. */
const renderPrintQr = (canvas: HTMLCanvasElement, link: string): Promise<void> =>
  QRCode.toCanvas(canvas, link, { width: 1024, margin: 2, errorCorrectionLevel: 'H', color: { dark: '#000000', light: '#ffffff' } });

/**
 * A4/Letter poster for the shop counter. Hidden on screen; the print stylesheet shows only this
 * element, so window.print() lets the owner print it or save it as PDF.
 */
export const createPoster = async (number: string, link: string): Promise<HTMLElement> => {
  const canvas = el('canvas', { className: 'poster__qr' });
  await renderPrintQr(canvas, link);
  const step = (index: number, text: string): HTMLElement =>
    el('li', { className: 'poster__step' }, [el('span', { className: 'poster__index', text: String(index) }), el('span', { text })]);
  return el('section', { className: 'poster', ariaLabel: t('inbox.print') }, [
    el('div', { className: 'poster__brand' }, [el('span', { className: 'poster__orb' }), el('span', { text: 'Sync Port' })]),
    el('h1', { className: 'poster__title', text: t('poster.title') }),
    canvas,
    el('div', { className: 'poster__label', text: t('poster.number') }),
    el('div', { className: 'poster__number', text: formatPin(number) }),
    el('ol', { className: 'poster__steps' }, [step(1, t('poster.step1')), step(2, t('poster.step2', { link })), step(3, t('poster.step3'))]),
    el('div', { className: 'poster__footer', text: t('poster.footer') }),
  ]);
};

/** Mounts the poster once and opens the browser's print dialog. */
export const printPoster = async (number: string, link: string): Promise<void> => {
  document.querySelector('.poster')?.remove();
  document.body.append(await createPoster(number, link));
  window.print();
};
